export default [
  { label: 'Male', value: '0' },
  { label: 'Female', value: '1' },
  { label: 'Nonbinary', value: '3' },
  { label: 'N/A', value: '4' },
];
